'use client';

import { useNavigationAuthStatus } from '../NavigationHeader/useNavigationAuthStatus';
import { FullFooter } from '@/ui-components/organisms/Footer/FullFooter';
import { SimpleFooter } from '@/ui-components/organisms/Footer/SimpleFooter';
import type { FooterProps } from '@/ui-components/organisms/Footer/FullFooter.type';
import { resolveFooterLinks, type NavigationFooterGroup } from './navigationFooterLinks';

interface Props extends Omit<FooterProps, 'primaryLinks'> {
    type: 'Full' | 'Simple';
    primaryLinks: NavigationFooterGroup[];
}

export function AuthenticatedNavFooter({ type, primaryLinks, ...props }: Props) {
    const authenticationStatus = useNavigationAuthStatus();
    const Footer = type === 'Full' ? FullFooter : SimpleFooter;

    return (
        <Footer {...props} primaryLinks={resolveFooterLinks(primaryLinks, authenticationStatus === 'authenticated')} />
    );
}
